import styled from 'styled-components';

const Profile = styled.div`
  img {
    border-radius: 100%;
    max-width: 100%;
    width: 90px;
    height: 90px;
    margin: 20px 20px 20px 0;
    @media all and (max-width: 1439px),
      (max-height: 729px),
      (-webkit-device-pixel-ratio: 1.25) {
      width: 65px;
      height: 65px;
      margin: 5px 15px 5px 0;
    }
  }
  .user-title {
    margin: 0;
    font-size: 20px;
    line-height:23px;
    color: #424b50;
    font-family: "Roboto Slab";
    font-weight: 600;
  }
  .user-message {
    font-weight: 600;
    color: #5e7079;
    margin: 0;
    font-family: "Roboto";
    strong,
    a {
      color: #1EC252;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
    }
    .span {
      margin: 0 3px;
      color: #1EC252;
      font-weight: 600;
      cursor: pointer;
    }
  }
`;
const defaultProps = {
  label: '',
  pic: '',
  greyText: 'Enter your email',
  greenText: 'address',
  onClick: () => { },
};
type Props = {
  label?: string,
  pic?: string,
  onClick?: () => void,
  greyText?: string,
  greenText?: string,
} & typeof defaultProps;

const User = function User(props: Props) {
  const {
    label, pic, onClick, greyText, greenText,
  } = props;
  return (
    <Profile>
      <div className="d-flex align-items-center">
        {pic ? (
          <div className="flex-shrink-1">
            <img src={pic} alt={label} />
          </div>
        ) : null}
        <div className="flex-grow-1">
          {label && <p className="user-title">{label}</p>}

          <p className="user-message">
            {greyText}
            <span
              onKeyDown={onClick}
              role="button"
              tabIndex={0}
              className="span"
              onClick={onClick}
              aria-label={greenText}
            >
              {greenText}
              ...
            </span>
          </p>
        </div>
      </div>
    </Profile>
  );
};
User.defaultProps = defaultProps;
export default User;
